// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"154":"506a968d","6141":"cbfd7840","9525":"cbfd7840","9752":"cbfd7840"}[chunkId] + ".chunk.css";
};